define([
    "./nlgPasswordModule"
], function (passwordConfigModule) {
    "use strict";
    passwordConfigModule.provider("passwordConfig", [function () {
        var isShowValidationTooltip;

        this.configureShowValidationTooltip = function (showTooltipValidation) {
            isShowValidationTooltip = showTooltipValidation;
        };

        this.$get = [function () {
            return {
                isShowValidationTooltip: function() {
                    return isShowValidationTooltip;
                }
            };
        }];
    }]);
});
